import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import Dashboard from './views/dashboard/Dashboard.vue'
import Login from '@/views/login/Login'

Vue.use(Router)

const router = new Router({
  routes: [{
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Login
    },
    {
      path: '/orders',
      name: 'Order',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "about" */ '@/views/order/Order'),
      children: [{
          path: '',
          name: 'OrderOverview',
          meta: {
            requiresAuth: true
          },
          component: () => import( /* webpackChunkName: "about" */ '@/views/order/OrderOverview'),
        },
        {
          path: ':id',
          name: 'OrderDetail',
          meta: {
            requiresAuth: true
          },
          component: () => import( /* webpackChunkName: "about" */ '@/views/order/OrderDetail'),
        }
      ]
    },
    {
      path: '/storage-cards',
      name: 'StorageCard',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "about" */ '@/views/storage_card/StorageCard')
    },
    {
      path: '/customers',
      name: 'Zákazníci',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "about" */ '@/views/customer/Customer'),
    },
    {
      path: '/employees',
      name: 'Zamestnanci',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "about" */ '@/views/employee/Employee'),
    },
    {
      path: '/configurations',
      name: 'Configurácia',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "about" */ '@/views/configuration/Configuration'),
    },
    {
      path: '/manufacturing-commands',
      name: 'ManufacturingCommand',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "about" */ '@/views/manufacturing_command/ManufacturingCommand'),
      children: [{
          path: '',
          name: 'CommandOverview',
          meta: {
            requiresAuth: true
          },
          component: () => import( /* webpackChunkName: "about" */ '@/views/manufacturing_command/CommandOverview'),
        },
        {
          path: 'add',
          name: 'ManufacturingCommandAdd',
          meta: {
            requiresAuth: true
          },
          component: () => import( /* webpackChunkName: "about" */ '@/views/manufacturing_command/ManufacturingCommandAdd'),
        },
        {
          path: 'create',
          name: 'CommandCreate',
          meta: {
            requiresAuth: true
          },
          component: () => import( /* webpackChunkName: "about" */ '@/views/manufacturing_command/CommandCreate'),
        },
        {
          path: ':id',
          name: 'CommandUpdate',
          meta: {
            requiresAuth: true
          },
          component: () => import( /* webpackChunkName: "about" */ '@/views/manufacturing_command/CommandUpdate'),
        }
      ]
    },
    {
      path: '/workplaces',
      name: 'Workplace',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "about" */ '@/views/workplace/Workplace'),
      children: [{
          path: '',
          name: 'WorkplaceOverview',
          meta: {
            requiresAuth: true
          },
          component: () => import( /* webpackChunkName: "about" */ '@/views/workplace/WorkplaceOverview'),
        },
        {
          path: ':id',
          name: 'SpecificWorkplace',
          meta: {
            requiresAuth: true
          },
          component: () => import( /* webpackChunkName: "about" */ '@/views/workplace/SpecificWorkplace'),
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.getters.isAuthenticated == false) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router